module.exports = __webpack_public_path__ + "static/img/4.c195cd9d.png";